module.exports = __webpack_public_path__ + "img/sellsman.fd7dc24b.png";